var exports = {
  "N": "Link__JEKt-A",
  "I": "Icon__odI3dU",
};

module.exports = exports;
